/**
 * File: categories_provider.tsx
 * Description: Provides the CategoriesContext value to the public interface component tree, holding the FAQ categories state.
 */

import { CategoriesContext } from "@/context/public/categories_context";
import type { PropsWithChildren } from 'react';
import { ENDPOINT_PUBLIC_GET_ARTICLES } from "@/constants/endpoints_urls";
import { useCategoriesFetch } from "@/hooks/use_categories_fetch";

/**
 * Context provider that manages the FAQ categories state for the public interface.
 * Wrap the public page tree with this provider to make categories available via useCategoriesContext.
 *
 * @param {PropsWithChildren} props.children - Child components that will have access to the categories context.
 * @returns {JSX.Element} A CategoriesContext.Provider wrapping the given children.
 */
function CategoriesProvider({ children }: PropsWithChildren) {

    const categoriesState = useCategoriesFetch(ENDPOINT_PUBLIC_GET_ARTICLES);

    return (
        <CategoriesContext.Provider value={categoriesState}>
            {children}
        </CategoriesContext.Provider>
    );
}

export default CategoriesProvider
